import React, { useState } from 'react';
import { motion } from 'framer-motion';
import styles from './SectionProcess.module.scss';

const steps = [
  'DISCOVER',
  'PLAN',
  'DESIGN',
  'BUILD',
  'LAUNCH',
  'GROW'
];

const SectionProcess: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <section className={`${styles.processSection} light-section`} id="home-process">
      <div className="torn-edge-top" />
      <div className="container">
        <motion.div
          className={styles.headingWrapper}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className={styles.heading}>FROM IDEA TO IMPACT.</h2>
          <div className="gradient-line"></div>
        </motion.div>

        <div className={styles.timeline}>
          {steps.map((step, index) => (
            <motion.div
              key={step}
              className={`${styles.step} ${index === activeStep ? styles.active : ''}`}
              onMouseEnter={() => setActiveStep(index)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className={styles.connector} />
              <div className={styles.content}>
                <span className={styles.number}>0{index + 1}</span>
                <h3 className={styles.title}>{step}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionProcess;
